import { Beverage, SiteMenuOrder } from '.';
import Route from './route';
import Site from './site';
import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../jsonapi-provider';

@JsonApiResource({
  type: 'site-menu-beverage-order',
})
export default class SiteMenuBeverageOrder extends BaseEntity {
  @JsonApiProperty({ resolver: Number, readOnly: true }) unitPrice: number = 0.0;
  @JsonApiProperty({ resolver: Number, readOnly: true }) totalPrice: number = 0.0;
  @JsonApiProperty({ resolver: Number }) quantity: number = 0;
  isExtraBeverage: boolean = false;
  @JsonApiProperty({ type: 'string', readOnly: true }) beverageName: string = '';

  @JsonApiRelationship('site') site = new Site();
  @JsonApiRelationship('beverage') beverage = new Beverage();
  @JsonApiRelationship('route') route = new Route();
  @JsonApiRelationship('site-menu-order') siteMenuOrder = new SiteMenuOrder();
}

export interface SiteMenuBeverageOrderView
  extends Omit<SiteMenuBeverageOrder, 'site' | 'route' | 'siteMenuOrder' | 'beverage'> {}

export const toSiteMenuBeverageOrderView = (
  smbo: SiteMenuBeverageOrder
): SiteMenuBeverageOrderView => {
  return {
    unitPrice: smbo?.unitPrice,
    totalPrice: smbo?.totalPrice,
    quantity: smbo?.quantity,
    isExtraBeverage: smbo?.isExtraBeverage,
    beverageName: smbo?.beverageName,
  };
};
